import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import { PiDotsThreeOutlineVerticalFill } from "react-icons/pi";
import { TbTargetArrow } from "react-icons/tb";
import {
  IoIosStar,
  IoIosStarOutline,
  IoMdInformationCircleOutline,
} from "react-icons/io";
import { FaFileInvoice, FaFileInvoiceDollar } from "react-icons/fa";
import Data from "../../data/data.json";
import useAuth from "../../hooks/useAuth";

const dailyupdate_dataa = [
  { value: "₹ 2.5 Cr", title: "Yesterdays Revenue", icon: <TbTargetArrow /> },
  {
    value: "50%",
    title: "This Month Target Vs Achievement",
    icon: <TbTargetArrow />,
  },
  { value: " ₹ 7800", title: "Average invoice value", icon: <FaFileInvoice /> },
  { value: "2.2", title: "Item per invoice", icon: <FaFileInvoiceDollar /> },
];
const mostVisitedArray = [
  {
    id: "67e39f1ea422a148f29b6beb",
    name: "IPL Team Valuation 2008-23",
    type: "workbook",
    favourite: false,
    icon: "https://res.cloudinary.com/dccfiolig/image/upload/v1742970748/screenshots/67e39f1e7db98d26cda56f9d_chart.png",
    selectedSheetId: "67e39f1e7db98d26cda56f9d",
    parentFolder: "66b4b31b5ae8edd2283da40a",
  },
  {
    id: "67ebdb3ceae75e8b74d72343",
    name: "Blinkit",
    type: "workbook",
    favourite: false,
    icon: "https://res.cloudinary.com/dccfiolig/image/upload/v1743579485/screenshots/67ebdb3c4416e8f10452bee9_dashboard.png",
    selectedSheetId: "67ebdb3c4416e8f10452bee9",
    parentFolder: "66b4b31b5ae8edd2283da40a",
  },
  {
    id: "67dd3bd3a422a148f28439fb",
    name: "Point Mapping",
    type: "workbook",
    favourite: false,
    icon: "https://res.cloudinary.com/dccfiolig/image/upload/v1742552823/screenshots/67dd3bd37db98d26cda56f5b_chart.png",
    selectedSheetId: "67dd3bd37db98d26cda56f5b",
    parentFolder: "66b4b31b5ae8edd2283da40a",
  },
  {
    id: "67458ab34439c230e532bdbf",
    name: "Target Vs. Achievement",
    type: "workbook",
    favourite: false,
    icon: "https://res.cloudinary.com/dccfiolig/image/upload/v1734672975/screenshots/0d785a43-fa89-4fc1-b593-6a27eaf3f864_dashboard.png",
    selectedSheetId: "6757bad91b117b49d2de5626",
    parentFolder: "66b4b31b5ae8edd2283da40a",
  },
  {
    id: "67f399b341a221213c73736a",
    name: "Human Hydro",
    type: "workbook",
    favourite: false,
    icon: "https://res.cloudinary.com/dccfiolig/image/upload/v1744018054/screenshots/67f399b32219a544fdc81cd7_dashboard.png",
    selectedSheetId: "67f399b32219a544fdc81cd7",
    parentFolder: "66b4b31b5ae8edd2283da40a",
  },
];
const trendingArray = [
  {
    id: "6728acd0b14daeaf61c5e797",
    name: "origin Destination",
    type: "workbook",
    favourite: false,
    icon: "https://firebasestorage.googleapis.com/v0/b/image-9bcce.appspot.com/o/screenshots%2Fscreenshot-1732266197992.png?alt=media&token=130ea3b7-c6fb-427d-b906-7a4615a6b976",
    selectedSheetId: "67737ec36018c0fd5d8a6b2e",
    parentFolder: "66b4b31b5ae8edd2283da40a",
  },
  {
    id: "67458ab34439c230e532bdbf",
    name: "Target Vs. Achievement",
    type: "workbook",
    favourite: false,
    icon: "https://res.cloudinary.com/dccfiolig/image/upload/v1734672975/screenshots/0d785a43-fa89-4fc1-b593-6a27eaf3f864_dashboard.png",
    selectedSheetId: "6757bad91b117b49d2de5626",
    parentFolder: "66b4b31b5ae8edd2283da40a",
  },
  {
    id: "675be4f3db8dcebfd171fdd9",
    name: "category wise sales",
    type: "workbook",
    favourite: false,
    icon: "https://firebasestorage.googleapis.com/v0/b/image-9bcce.appspot.com/o/screenshots%2Fscreenshot-1734075621301.png?alt=media&token=26335dea-1f5f-4995-a884-17a21a726c17",
    selectedSheetId: "675be4f37d54fba82e08df97",
    parentFolder: "66b4b31b5ae8edd2283da40a",
  },
  {
    id: "675bfe41af3b2fc3a626376d",
    name: "quantity Vs. Sales",
    type: "workbook",
    favourite: false,
    icon: "https://firebasestorage.googleapis.com/v0/b/image-9bcce.appspot.com/o/screenshots%2Fscreenshot-1734180826113.png?alt=media&token=a569afec-a474-44f3-a0e9-140aeaa7ae06",
    selectedSheetId: "675bfe411b626ef7b32a6654",
    parentFolder: "66b4b31b5ae8edd2283da40a",
  },
  {
    id: "67458ab34439c230e532bdbf",
    name: "Target Vs. Achievement",
    type: "workbook",
    favourite: false,
    icon: "https://res.cloudinary.com/dccfiolig/image/upload/v1734672975/screenshots/0d785a43-fa89-4fc1-b593-6a27eaf3f864_dashboard.png",
    selectedSheetId: "6757bad91b117b49d2de5626",
    parentFolder: "66b4b31b5ae8edd2283da40a",
  },
  {
    id: "679e04d101ae250650f13e8d",
    name: "region/category sales ",
    type: "workbook",
    icon: "https://res.cloudinary.com/dccfiolig/image/upload/v1738409180/screenshots/679dfeb91a8725e1683cb941_chart.png",
    selectedSheetId: "679e04d11a8725e1683cb942",
    parentFolder: "66b4b31b5ae8edd2283da40a",
  },
];
const getGreeting = () => {
  const hour = new Date().getHours();
  if (hour < 12) return "Good morning";
  if (hour < 18) return "Good afternoon";
  return "Good evening";
};
console.log(getGreeting());

export default function Welcome() {
  const { roles, username } = useAuth();
  const [welcomeConetntToDisplay, setWelcomeConetntToDisplay] = useState(
    Data.Most_visited.length
  );
  console.log(welcomeConetntToDisplay);
  const componentRef = useRef(null);
  const navigate = useNavigate();
  const { open } = useOutletContext();
  console.log(open);

  const updateItemsToShow = (open) => {
    if (componentRef.current) {
      const width = componentRef.current.offsetWidth;
      let display;
      if (width > 1200) {
        if (open) {
          display = 5;
        }
        display = 6;
      } else if (width > 1000) {
        display = 4;
      } else if (width > 800) {
        display = 3;
      } else if (width > 600) {
        display = 3;
      } else if (width > 400) {
        display = 3;
      } else {
        display = 1;
      }
      setWelcomeConetntToDisplay(display);
    }
  };

  useEffect(() => {
    updateItemsToShow(open);
    window.addEventListener("resize", updateItemsToShow);
    return () => window.removeEventListener("resize", updateItemsToShow);
  }, []);

  const handleShowMore = () => {
    navigate("/home/dash/trending");
  };
  const handleOpenWorkbook = (workbookId, sheetId) => {
    if (workbookId && sheetId) {
      if (roles.length === 0) {
        navigate(
          `/publicdashboard?workbookid=${workbookId}&sheetid=${sheetId}`
        );
      } else {
        navigate(`/dashboard?workbookid=${workbookId}&sheetid=${sheetId}`);
      }
    } else {
      console.log("selectedSheetId is null or undefined");
    }
  };

  return (
    <main
      ref={componentRef}
      className="w-full h-[94vh] min-h-[94vh] overflow-hidden overflow-y-auto flex flex-col gap-y-16"
    >
      <section className="w-full flex gap-3 px-6 py-6 justify-center items-center text-[60px] h-auto pacificoRegular bg-gradient-to-r from-[#69BFF9] to-[#0D0A70] bg-clip-text text-transparent opacity-90 drop-shadow-lg tracking-wide">
        Welcome to vizta
      </section>

      {/* Most Visited */}
      <section className="w-full flex flex-col gap-2 px-3 h-auto">
        <header className="flex justify-between items-center h-[10%]">
          <h3 className="font-[500]">Most Visited</h3>
          <button
            onClick={handleShowMore}
            className="text-sm underline text-blue-400"
          >
            Show More
          </button>
        </header>
        <section className="flex gap-x-5 gap-y-16 w-full h-[90%]">
          {mostVisitedArray
            .slice(0, welcomeConetntToDisplay)
            .map((item, index) => {
              // Conditionally skip the item at index 0 if state is true
              if (open && index === 0) {
                return null;
              }

              return (
                <section className="flex flex-col w-[230px] h-[180px] items-center justify-start gap-1">
                  <section
                    key={index}
                    className="w-full h-[90%] gap-3 bg-white rounded shadow-md cursor-pointer"
                  >
                    {item !== null && item.type === "folder" ? (
                      <img
                        className="w-full h-full object-contain"
                        src="/graph_img/file.png"
                        alt="Folder"
                      />
                    ) : (
                      <img
                        className="w-full h-full object-contain"
                        src={item !== null && item.icon}
                        alt="File"
                        onClick={() =>
                          handleOpenWorkbook(item.id, item.selectedSheetId)
                        }
                      />
                    )}
                  </section>{" "}
                  <div className="text-[14px] flex justify-between items-start w-full h-[10%]">
                    <h2 className="w-[80%] truncate">{item.name}</h2>
                    <section className="flex gap-3 relative items-start pt-[4px] w-[30%]">
                      {/* Toggle favorite status using handleFavoriteToggle */}
                      {item !== null && item.favourite ? (
                        <IoIosStar />
                      ) : (
                        <IoIosStarOutline />
                      )}
                      <IoMdInformationCircleOutline />
                      <PiDotsThreeOutlineVerticalFill className="text-black cursor-pointer" />
                    </section>
                  </div>
                </section>
              );
            })}
        </section>
      </section>

      {/* Trending */}
      <section className="w-full flex flex-col gap-2 px-3 h-auto">
        <header className="flex justify-between items-center h-[10%]">
          <h3 className="font-[500]">Most Trending</h3>
          <button
            onClick={handleShowMore}
            className="text-sm underline text-blue-400"
          >
            Show More
          </button>
        </header>
        <section className="flex gap-x-5 gap-y-16 w-full h-[90%]">
          {trendingArray
            .slice(0, welcomeConetntToDisplay)
            .map((item, index) => {
              // Conditionally skip the item at index 0 if state is true
              if (open && index === 0) {
                return null;
              }

              return (
                <section className="flex flex-col w-[230px] h-[180px] items-center justify-start gap-1">
                  <section
                    key={index}
                    className="w-full h-[90%] gap-3 bg-white rounded shadow-md cursor-pointer"
                  >
                    {item !== null && item.type === "folder" ? (
                      <img
                        className="w-full h-full object-contain"
                        src="/graph_img/file.png"
                        alt="Folder"
                      />
                    ) : (
                      <img
                        className="w-full h-full object-contain"
                        src={item !== null && item.icon}
                        alt="File"
                        onClick={() =>
                          handleOpenWorkbook(item.id, item.selectedSheetId)
                        }
                      />
                    )}
                  </section>{" "}
                  <div className="text-[14px] flex justify-between items-start w-full h-[10%]">
                    <h2 className="w-[80%] truncate">{item.name}</h2>
                    <section className="flex gap-3 relative items-start pt-[4px] w-[30%]">
                      {/* Toggle favorite status using handleFavoriteToggle */}
                      {item !== null && item.favourite ? (
                        <IoIosStar />
                      ) : (
                        <IoIosStarOutline />
                      )}
                      <IoMdInformationCircleOutline />
                      <PiDotsThreeOutlineVerticalFill className="text-black cursor-pointer" />
                    </section>
                  </div>
                </section>
              );
            })}
        </section>
      </section>
    </main>
  );
}
